import React from 'react';
import './background.css';

function Background() {
  return (
    <div className="container">
      <div className="shape"></div>
      <div className="shape"></div>
      <div className="shape"></div>
      <div className="shape"></div>
      <div className="shape"></div>
      <div className="shape"></div>
    </div>
  );
}

export default Background;
